import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { usePassengerState } from '../../../hooks';
import Radio from '../../../../../Radio';
import { getBaggageServicesCalculatedCountInfo } from '../../../store/selector';
import { getGdsServiceCalculatedCountInfo } from '@shared/lib/gdsService/getGdsServiceCalculatedCountInfo';
const PassengerBaggageRadio = ({ className, passenger, baggages, segmentIds, segmentId, disabled, onChange }) => {
    const { BaggagePassenger: css } = useTheme('UpgradeBaggageDialog');
    const { items, selectedCount } = usePassengerState(passenger, baggages, segmentIds, segmentId);
    const gdsServicesCalculatedCountInfo = useSelector(getBaggageServicesCalculatedCountInfo);
    const canAddedCount = React.useMemo(() => {
        var _a;
        const segmentId = segmentIds[0];
        const baggage = baggages[0];
        return (_a = getGdsServiceCalculatedCountInfo(passenger.id, segmentId, gdsServicesCalculatedCountInfo, {
            rfisc: baggage === null || baggage === void 0 ? void 0 : baggage.rfics,
            subType: baggage === null || baggage === void 0 ? void 0 : baggage.type
        })) === null || _a === void 0 ? void 0 : _a.diffCount;
    }, [gdsServicesCalculatedCountInfo, baggages, segmentIds, passenger]);
    const isChecked = !!selectedCount;
    const isDisabled = disabled || (canAddedCount === 0 && !isChecked);
    const onChangeHandler = useCallback((_) => {
        const changedItems = items
            .filter(item => !segmentId || (segmentId && item.segmentIds.includes(segmentId)))
            .map(item => (Object.assign(Object.assign({}, item), { count: isChecked ? 0 : 1 })));
        onChange(changedItems);
    }, [isChecked, segmentId, items, onChange]);
    return (React.createElement("div", { className: cn(css.checkbox_wrapper, className) },
        React.createElement(Radio, { classes: {
                root: css.checkbox_root,
                checked: css.checkbox_rootChecked
            }, checked: isChecked, disabled: isDisabled, onClick: onChangeHandler })));
};
export default PassengerBaggageRadio;
